export default __webpack_public_path__ + "static/media/error_msg_icon.d3bdc7e8.svg";